import {eventIsPremium} from '~/common/fabric/reducers/details/selectors';
import {PLAN_NAME_PARTY_PASS, PLAN_NAME_PRO} from '~/common/fabric/routes/EventReview/constants';
import {isInNewGiftingUIVariation} from '~/CreateFabricInvitation/utils/experiments';

export const selectGiftOptions = ({giftingOptions}) => giftingOptions.options;

export const selectIsPremiumTemplate = ({fabricTemplate}) => fabricTemplate.premium;

export const selectRegistryRecipient = ({giftingOptions}) => giftingOptions?.gift_registry_name;
export const selectRegistryNote = ({giftingOptions}) => {
  if (isInNewGiftingUIVariation()) {
    return giftingOptions?.gift_registry_note || '';
  }
  return '';
};
export const selectForceShowModule = ({giftingOptions}) => giftingOptions?.force_show_module;
export const selectRegistryType = ({giftingOptions}) => giftingOptions?.gift_registry_type;
export const selectRegistryWording = ({giftingOptions}) =>
  giftingOptions?.gift_registry_type === 'wishlist' ? 'wishlist' : 'gift registry';

export const selectPledgeling = ({giftingOptions}) => giftingOptions.pledgeling_data;
export const selectRegistryUrls = ({giftingOptions}) => giftingOptions?.gift_registry_urls;
export const selectGiftingOptions = ({giftingOptions}) => giftingOptions;
export const selectGiftingOptionsOptions = ({giftingOptions}) => giftingOptions.options;

export const selectRegistryLen = ({giftingOptions}) => giftingOptions.gift_registry_urls.length > 0;

export const selectCrowdfund = ({giftingOptions}) => giftingOptions.pledgeling_data?.Crowdfund;

export const selectCharityID = ({giftingOptions}) =>
  giftingOptions.pledgeling_data?.Organization?.pledgeling_id;

export const selectCrowdfundPurpose = ({giftingOptions}) =>
  giftingOptions.pledgeling_data?.Crowdfund?.pledgeling_purpose;

export const selectCrowdfundOrganization = ({giftingOptions}) =>
  giftingOptions.pledgeling_data?.Crowdfund?.Organization;

export const selectShowGifting = ({giftingOptions}) =>
  giftingOptions.options.event_option_show_gifting;
export const selectGiftingOptionsUpgraded = ({giftingOptions}) => giftingOptions.upgraded;
export const selectGiftingUpgradable = (state) => {
  const premium = eventIsPremium(state);

  const registryLen = selectRegistryLen(state);
  const charityID = selectCharityID(state);
  const purpose = selectCrowdfundPurpose(state);

  return (
    premium ||
    registryLen ||
    charityID ||
    purpose ||
    state.user?.subscriptionPlanName === PLAN_NAME_PRO ||
    state.user?.subscriptionPlanName === PLAN_NAME_PARTY_PASS ||
    state.eviteEvent.status !== 'draft'
  );
};

export const selectGiftOptionsMissing = (state) => {
  const premium = selectIsPremiumTemplate(state);

  const registryLen = selectRegistryLen(state);
  const charityID = selectCharityID(state);
  const purpose = selectCrowdfundPurpose(state);

  const showGifting = selectShowGifting(state);

  return (
    !premium &&
    !registryLen &&
    !charityID &&
    !purpose &&
    !showGifting &&
    !state.user?.subscriptionPlanName !== PLAN_NAME_PRO &&
    !state.user?.subscriptionPlanName !== PLAN_NAME_PARTY_PASS
  );
};

export const selectGiftOptionsCount = (state) => {
  let count = 0;

  if (selectRegistryLen(state)) count++;
  if (selectCharityID(state)) count++;
  if (selectCrowdfundPurpose(state)) count++;
  if (selectShowGifting(state)) count++;

  return count;
};

export const selectGiftOptionsCountInComponent = (state) => {
  let count = 0;
  const giftOptions = state.giftingOptions;
  if (giftOptions.gift_registry_urls?.length > 0) count++;
  if (giftOptions.pledgeling_data.Crowdfund?.pledgeling_beneficiary_type) count++;
  if (giftOptions.pledgeling_data.Organization?.pledgeling_beneficiary_type) count++;
  if (giftOptions.showGifting) count++;
  return count;
};

export const selectPhotosEnabled = ({giftingOptions}) =>
  giftingOptions?.options?.event_option_enable_photo_sharing;

export const selectHostPhotoGalleryEnabled = ({giftingOptions}) =>
  giftingOptions?.options?.event_option_enable_host_photo_gallery;

export const selectConfirmDeleteLastRegistry = (state) => {
  const charityId = selectCharityID(state);
  const purpose = selectCrowdfundPurpose(state);
  const showGifting = selectShowGifting(state);
  const registries = selectRegistryUrls(state);

  return !showGifting && !purpose && !charityId && registries.length <= 1;
};
